import React from "react";

import Hoc from "./util/Hoc";

import Header from "./containers/layout/Header";
// import NavigationMenu from "./components/navigation/NavigationMenu";
import NavigationPanel from "./components/navigation/NavigationPanel";
import Body from "./containers/layout/Body";
import Footer from "./containers/layout/Footer";

import * as CvSections from "./util/CvSections";

import "./App.css";

const app = (props) => {

  let cvParts = [];
  for (const key in CvSections.CV_PARTS) {
    cvParts.push({ [key]: CvSections.CV_PARTS[key].sections, icon : CvSections.CV_PARTS[key].icon });
  }
 
  return (
    <Hoc>
      <Header />
      {/* <NavigationMenu {...props} cvParts={cvParts}/> */}
      <NavigationPanel {...props} cvParts={cvParts}/>
      <Body {...props} cvParts={cvParts}/>
      <Footer {...props} cvParts={cvParts}/>
    </Hoc>
  );
};

export default app;
